import * as rolesUtils from '@app/role.utils';
import { compareAsc, compareDesc, parseISO } from 'date-fns';

// export const groupBy = (list, keyGetter) => {
//   const map = new Map();
//   list.forEach(item => {
//     const key = keyGetter(item);
//     const collection = map.get(key);
//     if (!collection) {
//       map.set(key, [item]);
//     } else {
//       collection.push(item);
//     }
//   });
//   return map;
// };
export const groupBy = (list, keyGetter) => {
  return list.reduce((obj, item) => {
    const key = keyGetter(item);
    if (obj[key]) {
      obj[key] = [...obj[key], item];
    } else {
      obj[key] = [item];
    }
    return obj;
  }, {});
  // const map = new Map();
  // list.forEach(item => {
  //
  //   const collection = map.get(key);
  //   if (!collection) {
  //     map.set(key, [item]);
  //   } else {
  //     collection.push(item);
  //   }
  // });
  // return map;
};

export const getObjectsDiff = (oldObj, newObj) => {
  let result = {};
  Object.keys(newObj).map(key => {
    if (newObj[key] && typeof newObj[key] === 'object') {
      const nestedDiff = getObjectsDiff(oldObj[key], newObj[key]);
      if (nestedDiff) {
        result[key] = nestedDiff;
      }
    } else {
      if (!oldObj[key] || oldObj[key] !== newObj[key]) {
        result[key] = newObj[key];
      }
    }
  });
  result = result !== {} ? result : null;
  return result;
};

export const compact = array => {
  return array.filter((value, index, self) => {
    return self.indexOf(value) === index;
  });
};

export const camelize = str =>
  str
    .split(' ')
    .map(
      (word, index) =>
        word.charAt(0)[index === 0 ? 'toLowerCase' : 'toUpperCase']() +
        word.toLowerCase().slice(1)
    )
    .join('');

export const sortObjectsByDate = (items, field, order?) => {
  order = order ? order : 'ASC';

  return items.sort((a, b) => {
    const left = parseISO(a[field]);
    const right = parseISO(b[field]);

    if (order === 'ASC') {
      return compareAsc(left, right);
    } else {
      return compareDesc(left, right);
    }
  });
};
export const fetchImageId = product => {
  let finalImage;
  const product_pictures = {};

  if (product && product.Pictures) {
    product.Pictures.forEach((p) => {
      if (p.name !== null && p.name !== "" && !p.name.includes(".")) {
        const name = p.name.split("_")
        product_pictures[name[1].toString()] = product_pictures[name[1].toString()] || [];
        product_pictures[name[1].toString()].push(p)
      } else {
        product_pictures[p.metadata.position.toString()] = product_pictures[p.metadata.position.toString()] || [];
        product_pictures[p.metadata.position.toString()].push(p)
      }
    })
  }
  if (!Object.keys(product_pictures).length) {
    return 'assets/no-picture.png'
  }
  
  if (Object.keys(product_pictures).includes("1")) {
    finalImage = product_pictures["1"].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    return finalImage["0"].id
  }

  if (Object.keys(product_pictures).includes("2")) {
    finalImage = product_pictures["2"].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    return finalImage["0"].id
  }

  if (Object.keys(product_pictures).includes("3")) {
    finalImage = product_pictures["3"].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    return finalImage["0"].id
  }
};


export const fetchImage = product => {
  let finalImage;
  const product_pictures = {};

  if (product && product.Pictures) {
    product.Pictures.forEach((p) => {
      if (p && p.name !== null && p.name !== ""
        //  && !p.name.includes(".")
        ) {
        const name = p.name.split("_")
        // console.log("LENGTH", name.length)
        if (name.length > 1) {
          product_pictures[name[1].toString()] = product_pictures[name[1].toString()] || [];
          product_pictures[name[1].toString()].push(p)
        }
      } else {
        product_pictures[p.metadata.position.toString()] = product_pictures[p.metadata.position.toString()] || [];
        product_pictures[p.metadata.position.toString()].push(p)
      }
    })
  }
  if (Object.keys(product_pictures).length === 0) {
    return 'assets/no-picture.png'
  }

  if (Object.keys(product_pictures).includes("1")) {
    finalImage = product_pictures["1"].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    return finalImage["0"].fileUrl
  }
  
  if (Object.keys(product_pictures).includes("2")) {
    finalImage = product_pictures["2"].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    return finalImage["0"].fileUrl
  }
  
  if (Object.keys(product_pictures).includes("3")) {
    finalImage = product_pictures["3"].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    return finalImage["0"].fileUrl
  }
  // console.log('ORDER PRODUCTS', product_pictures)
  // if (product_pictures) {
  //   if (product_pictures['1']) {
  //     firstt = product_pictures['1'].sort((a, b) => {
  //       if (b.createdAt > a.createdAt) {
  //         return 1;
  //       }
  //       if (b.createdAt < a.createdAt) {
  //         return -1;
  //       }
  //       return 0;
  //     });
  //   }
  //   if (product_pictures['2']) {
  //     secondd = product_pictures['2'].sort((a, b) => {
  //       if (b.createdAt > a.createdAt) {
  //         return 1;
  //       }
  //       if (b.createdAt < a.createdAt) {
  //         return -1;
  //       }
  //       return 0;
  //     });
  //   }

  //   if (product_pictures['3']) {
  //     thirdd = product_pictures['3'].sort((a, b) => {
  //       if (b.createdAt > a.createdAt) {
  //         return 1;
  //       }
  //       if (b.createdAt < a.createdAt) {
  //         return -1;
  //       }
  //       return 0;
  //     });
  //   }
  // }

  // if (product_pictures) {
  //   try {
  //     if (firstt) {
  //       return firstt['0'].fileUrl;
  //     }
  //     if (secondd) {
  //       return secondd['0'].fileUrl;
  //     }
  //     if (thirdd) {
  //       return thirdd['0'].fileUrl;
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     return 'assets/no-picture.png';
  //   }
  // } else {
  //   return 'assets/no-picture.png';
  // }
};

export const isDevModeCB = me => {
  // const CountryDev = [10 , 30];

  if (me && rolesUtils.isCountryUser(me.role)) {
    if (me.CountryId === 30) {
      return false;
    }

    if (me.CountryId === 10 && me.businessUnit === 'SUPERMERCADOS') {
      return false;
    }
  }

  return true;
};
